import defaultImg from "../../images/default.png";

export const rightSidebarThemeData = [
  {
    id: "default",
    label: "Default",
    themeImage: defaultImg,
  },
];

export const rightSidbarLayoutWidthData = [
  {
    id: `fluid`,
    label: "Fluid",
  },
  {
    id: "boxed",
    label: "Boxed",
  },
];

export const rightSidbarLayoutPositionData = [
  {
    id: "fixed",
    label: "Fixed",
  },
  {
    id: "scrollable",
    label: "Scrollable",
  },
];

export const rightSidbarTopbarColorData = [
  {
    id: "light-color",
    label: "Light",
  },
  {
    id: "dark-color",
    label: "Dark",
  },
];

export const rightSidebarImagesData = [
  {
    id: "none",
    bgColor: "bg-transparent",
  },
  {
    id: "snow",
    bgImage: "bg-sidebar-snow",
  },
  {
    id: "office",
    bgImage: "bg-sidebar-office",
  },
  {
    id: "pattern",
    bgImage: "bg-sidebar-pattern",
  },
  {
    id: "bubble",
    bgImage: "bg-sidebar-bubble",
  },
];

export const rightSidebarPrimaryColorData = [
  {
    id: "default",
    bgColor: "bg-[#0D0D12]", // DEBUG
  },
  {
    id: "teal-green",
    bgColor: "bg-[#066b5e]",
  },
  {
    id: "royal-purple",
    bgColor: "bg-[#5147A3]",
  },
  {
    id: "cobalt-blue",
    bgColor: "bg-[#2a5fc1]",
  },
];
